import React from "react";
import { Col } from "reactstrap";
import horSeal from "assets/img/HOR.png";
import horLogoText from "assets/img/HOR_3.png";
import DropdownSearch from "components/customs/dropdownSearch";
import { congressmanSearch } from "services/services.navbar";
import _ from "lodash";
import { useNavigate } from "react-router";
import styled from "styled-components";

const HorSealSection = styled.div`
  margin-top: 6rem;
  display: flex;
  justify-content: center;

  @media (max-width: 575.98px) {
    img {
      width: 100px;
    }
  }
`;

const HorTextLogoSection = styled.div`
  display: flex;
  justify-content: center;

  img {
    min-width: 250px;
    max-height: 200px;
  }

  @media (max-width: 575.98px) {
    img {
      width: 100%;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
`;

const DropdownSearchSection = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

const Main = () => {
  const navigate = useNavigate();

  const handleOnSearch = _.debounce((inputValue, callback) => {
    congressmanSearch({
      inputValue,
      callback,
    });
  }, 1000);

  const handleOnChange = (selectedOption) => {
    if (!selectedOption) return;

    // eslint-disable-next-line max-len
    const url = `/representatives/${selectedOption?.region?.id}/cong/${selectedOption?.id}`;

    navigate(url);
  };

  return (
    <>
      <HorSealSection>
        <img
          alt="horSeal"
          src={horSeal}
        />
      </HorSealSection>
      <HorTextLogoSection>
        <img
          alt="horLogo"
          src={horLogoText}
        />
      </HorTextLogoSection>
      <DropdownSearchSection>
        <Col
          xs="7"
          sm="6"
          md="6"
          lg="5"
          xl="4"
        >
          <DropdownSearch
            placeholder="Search"
            loadOptions={handleOnSearch}
            onChange={handleOnChange}
          />
        </Col>
      </DropdownSearchSection>
    </>
  );
};

export default Main;
